'use client';

import React, { useState } from 'react';
import Image from 'next/image';

interface AppImageProps {
    src: string;
    alt: string;
    width?: number;
    height?: number;
    className?: string;
    priority?: boolean;
    quality?: number;
    placeholder?: 'blur' | 'empty';
    blurDataURL?: string;
    fill?: boolean;
    sizes?: string;
    onClick?: () => void;
    fallbackSrc?: string;
    [key: string]: any;
}

const AppImage = (props: AppImageProps) => {
  const {
    className,
    src = '/assets/images/no_image.png',
    alt,
    priority = false,
    ...restProps
  } = props;

  // Determine if this image should be prioritized (for LCP optimization)
  const shouldPrioritize = priority || src?.includes('no_image.png');

  return (
    <Image
      className={className}
      src={src}
      alt={alt || 'Image'}
      loading={shouldPrioritize ? undefined : 'lazy'}
      priority={shouldPrioritize}
      onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
        e.currentTarget.src = '/assets/images/no_image.png';
      }}
      {...restProps}
    />
  );
};

export default AppImage;